var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Index"}},[_c('HeroHomepage'),_c('SectionProjects',{attrs:{"displayCount":6}}),_c('SectionApva'),_c('CalculatorReservable'),_c('SectionHowToBecome'),_c('SectionNews'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }